<template>
  <div class="spinner" :class="{ white: color === 'white' }">
    <div class="spinner-a"></div>
    <div class="spinner-b"></div>
    <div class="spinner-c"></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    color: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/spinners';

.spinner {
  @include pulse-spinner();
}
</style>
